/* Vertaalt vaste Spaanse teksten (aangepaste Liquid-blokken, winkelwagen-app) naar het Nederlands. Wordt alleen geladen op /nl. */
(function () {
  if (window.__velsenNl) return;
  window.__velsenNl = true;

  var SUB = [
    ['¡Llévate más y ahorra!', 'Neem meer mee en bespaar!'],
    ['MÁS ELEGIDO', 'MEEST GEKOZEN'],
    ['Y si superas los 90 €, te regalamos 10 €', 'En als je meer dan €90 besteedt, geven we je €10'],
    ['Llega a 90 € y llévate un cupón de 10 € para tu próxima compra o para una amigo.', 'Kom tot €90 en ontvang een coupon van €10 voor je volgende aankoop of voor een vriend.'],
    ['Recibirás un cupón de 10 € en el email de confirmación del pedido, para tu próxima compra o para una amigo.', 'Je ontvangt een coupon van €10 in de bevestigingsmail van je bestelling, voor je volgende aankoop of voor een vriend.'],
    ['para tu próxima compra o para una amigo.', 'voor je volgende aankoop of voor een vriend.'],
    ['El descuento se aplica automáticamente en el carrito. Puedes combinar diseños y tamaños.', 'De korting wordt automatisch toegepast in het winkelwagentje. Je kunt ontwerpen en maten combineren.'],
    ['¡Enhorabuena, has conseguido tu regalo!', 'Gefeliciteerd, je hebt je cadeau verdiend!'],
    ['¡Te faltan ', 'Nog '],
    [' para tu regalo!', ' tot je cadeau!'],
    ['Envío gratuito', 'Gratis verzending'],
    ['Devoluciones en 30 días', 'Retourneren binnen 30 dagen'],
    ['Pago 100% seguro', '100% veilig betalen'],
    ['Guía de tallas', 'Maattabel'],
    ['Stock Limitado', 'Beperkte voorraad'],
    ['Tu carrito esta vacío', 'Je winkelwagen is leeg'],
    ['Seguir comprando', 'Verder winkelen'],
    ['También podría gustarte', 'Misschien vind je dit ook leuk'],
    ['Añade estos productos', 'Voeg deze producten toe'],
    ['Protección de envío + Embalaje Prioritario', 'Verzendbescherming + Prioriteitsverpakking'],
    ['Añadir al carrito', 'In winkelwagen'],
    ['Precio total', 'Totaalprijs']
  ];
  var RE = [
    [/(\d+)\s+artículos/g, '$1 artikelen'],
    [/Ahorras\s+/g, 'Je bespaart '],
    [/Carrito\s*•\s*(\d+)/g, 'Winkelwagen • $1'],
    [/¡(\d+)% de descuento desbloqueado!/g, '$1% korting ontgrendeld!'],
    [/¡Añade (\d+) artículo\(s\) más y consigue un (\d+)% de descuento!/g, 'Voeg nog $1 artikel(en) toe en krijg $2% korting!'],
    [/¡(\d+)% de descuento activado! Se aplicará automáticamente en el carrito\./g, '$1% korting geactiveerd! Wordt automatisch toegepast in je winkelwagen.']
  ];
  var EXACT = { 'Añadir': 'Toevoegen' };

  function tr(s) {
    var t = s.trim();
    if (!t) return s;
    if (EXACT[t]) return s.replace(t, EXACT[t]);
    var out = s, i;
    for (i = 0; i < SUB.length; i++) {
      if (out.indexOf(SUB[i][0]) !== -1) out = out.split(SUB[i][0]).join(SUB[i][1]);
    }
    for (i = 0; i < RE.length; i++) out = out.replace(RE[i][0], RE[i][1]);
    return out;
  }

  function walk(root) {
    var w = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, {
      acceptNode: function (n) {
        var p = n.parentNode && n.parentNode.nodeName;
        return (p === 'SCRIPT' || p === 'STYLE' || p === 'TEXTAREA' || p === 'NOSCRIPT') ? NodeFilter.FILTER_REJECT : NodeFilter.FILTER_ACCEPT;
      }
    });
    var n, list = [];
    while ((n = w.nextNode())) list.push(n);
    list.forEach(function (node) {
      var v = tr(node.nodeValue);
      if (v !== node.nodeValue) node.nodeValue = v;
    });
  }

  var timer = null;
  function run() { walk(document.body); }
  function start() {
    run();
    new MutationObserver(function () {
      clearTimeout(timer);
      timer = setTimeout(run, 50);
    }).observe(document.body, { childList: true, subtree: true, characterData: true });
  }
  if (document.body) start(); else document.addEventListener('DOMContentLoaded', start);
})();